// extracted by mini-css-extract-plugin
export default {"select":"HorarioCellEditor_select__BQWCY"};